import React from 'react'
import styled from 'styled-components'

import { Button } from '../../styles/Buttons'
import { Heading2, Heading3, Paragraph } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Wrapper = styled.div`
  display: flex;
  column-gap: 32px;
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 50%;
  min-height: 341px;
  padding: 8px 16px 16px;
  border-radius: 8px;
  background-color: ${(p) => p.theme.blue};
  color: white;
  :nth-child(2) {
    background-color: ${(p) => p.theme.textColor};
  }
`

const ItemHeading = styled(Heading3)``

const ItemText = styled.div`
  margin-top: 8px;
`

const ItemButtonWrapper = styled.div`
  padding-top: 32px;
  margin-top: auto;
`

const CallToAction = () => {
  return (
    <>
      <Heading>Call to action</Heading>
      <Wrapper>
        <Item>
          <ItemHeading>Heading</ItemHeading>
          <ItemText>
            <Paragraph>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna.
            </Paragraph>
          </ItemText>
          <ItemButtonWrapper>
            <Button dark>Sign up for free</Button>
          </ItemButtonWrapper>
        </Item>
        <Item>
          <ItemHeading>Heading</ItemHeading>
          <ItemText>
            <Paragraph>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna.
            </Paragraph>
          </ItemText>
          <ItemButtonWrapper>
            <Button reversedWhite textColor="#300D4F">
              Contact our team
            </Button>
          </ItemButtonWrapper>
        </Item>
      </Wrapper>
    </>
  )
}

export default CallToAction
